export default [
  { title: "Dashboard", icon: "$dashboard", link: "/dashboard" , permission: 'Dashboard'},
  { title: "Kelola Program", icon: "$program", link: "/program", permission: 'Program' },
  { title: "Reseller", icon: "ri-user-line", link: "/daftar-reseller", permission: 'Reseller' },
  { title: "Notifikasi", icon: "ri-chat-settings-line", link: "/notifikasi", permission: 'Notification' },
  { title: "Presensi", icon: "ri-list-check-2", link: "/presensi", permission: 'Presensi' },
  { title: "Import Data", icon: "ri-upload-cloud-2-line", link: "/import", permission: 'Import' },
  // { title: "Sertifikat", icon: "ri-award-fill", link: "/update-content" },
];
